import React, { useEffect, useRef, useState } from "react";
import "./Chat.css";

const ChatWidget = () => {
    const token = process.env.REACT_APP_CHAT_TOKEN;
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [consent, setConsent] = useState(false);
    const [phoneError, setPhoneError] = useState(false); // 👈 nouveau state
    const messageRef = useRef(null);

    useEffect(() => {
        const openChat = (event) => {
            const presetMessage = event.detail?.message;
            setSent(false);
            setOpen(true);
            if (typeof presetMessage === "string" && presetMessage.trim()) {
                setMsg(presetMessage);
            }
        };

        window.addEventListener("open-amservices-chat", openChat);
        return () => window.removeEventListener("open-amservices-chat", openChat);
    }, []);

    useEffect(() => {
        if (open && !sent) messageRef.current?.focus();
    }, [open, sent]);

    const validatePhone = (value) => {
        // tu peux adapter la logique ici selon ton format attendu
        const valid = value.trim().length >= 10;
        setPhoneError(!valid);
        return valid;
    };

    const send = async () => {
        if (!msg.trim() || msg.trim().length < 5 || !consent || !validatePhone(phone)) return;

        setLoading(true);

        try {
            const res = await fetch("https://www.amservices.eu/api/intake.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    message: msg.trim(),
                    email,
                    phone,
                    pageUrl: typeof window !== "undefined" ? window.location.href : "",
                    ua: typeof navigator !== "undefined" ? navigator.userAgent : ""
                })
            });

            const text = await res.text();
            let j;
            try {
                j = JSON.parse(text);
            } catch {
                j = { ok: false };
            }

            if (j.ok) {
                setSent(true);
                setMsg("");
                setPhone("");
                setEmail("");
                setConsent(false);
                setPhoneError(false);
            } else {
                alert("Erreur: " + (j.error || "inconnue"));
            }
        } catch (e) {
            console.error("fetch error", e);
            alert("Erreur réseau, réessayez.");
        }

        setLoading(false);
    };

    return (
        <>
            <button
                aria-label="Ouvrir le chat"
                onClick={() => setOpen((v) => !v)}
                className="chat-launch"
            >
                💬
            </button>

            {open && (
                <div className="chat-panel">
                    <div className="chat-header">Posez votre question / Demandez un devis</div>
                    <div className="chat-body">
                        {!sent ? (
                            <>
                                <textarea
                                    ref={messageRef}
                                    value={msg}
                                    onChange={(e) => setMsg(e.target.value)}
                                    placeholder="Décrivez votre besoin. Ex: PC pro 16 Go RAM, 1 To SSD…"
                                    className="chat-textarea"
                                    rows={4}
                                />
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Email (optionnel)"
                                    type="email"
                                    className="chat-input"
                                />
                                <input
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e.target.value);
                                        validatePhone(e.target.value);
                                    }}
                                    placeholder="Numéro obligatoire"
                                    type="tel"
                                    className={`chat-input ${phoneError ? "chat-input-error" : ""}`} // 👈 ajout de la classe erreur
                                />
                                {phoneError && (
                                    <div style={{ color: "var(--chat-red)", fontSize: 12 }}>
                                        Veuillez entrer un numéro valide.
                                    </div>
                                )}
                                <label className="chat-consent">
                                    <input
                                        type="checkbox"
                                        checked={consent}
                                        onChange={(e) => setConsent(e.target.checked)}
                                    />
                                    <span>
                                        J’accepte le traitement de ma demande selon la{" "}
                                        <a href="/mentionlegal" target="_blank" rel="noreferrer">
                                            politique de confidentialité
                                        </a>.
                                    </span>
                                </label>

                                <button
                                    onClick={send}
                                    disabled={
                                        loading ||
                                        !msg.trim() ||
                                        msg.trim().length < 5 ||
                                        phone.trim().length < 9 ||
                                        !consent
                                    }
                                    className="chat-send"
                                >
                                    {loading ? "Envoi…" : "Envoyer"}
                                </button>

                                <div className="chat-note">
                                    Pas de bot. Réponse par email ou téléphone si fourni.
                                </div>
                            </>
                        ) : (
                            <div className="chat-thanks">
                                Merci. Nous revenons vers vous rapidement.
                                <div style={{ marginTop: 8 }}>
                                    <button
                                        onClick={() => setSent(false)}
                                        style={{
                                            fontSize: 12,
                                            border: "1px solid #ddd",
                                            padding: "6px 8px",
                                            borderRadius: 6
                                        }}
                                    >
                                        Envoyer une autre demande
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ChatWidget;
